import type { ReactNode } from "react";

export type PillTabNavItem = Readonly<{
  id: string;
  label: ReactNode;
  componentInstance?: string;
}>;

export type PillTabNavProps = Readonly<{
  activeId: string;
  ariaLabel: string;
  items: readonly PillTabNavItem[];
  onChange: (id: string) => void;
  className?: string;
  componentInstance?: string;
  sticky?: boolean;
}>;

const NAV_CLASS = "dj-pill-tab-nav";
const TAB_CLASS = "dj-pill-tab";
const ACTIVE_CLASS = "dj-pill-tab--active";

/**
 * App-wide pill menu tab bar (white rounded container, primary active pill,
 * muted gray hover on inactive tabs).
 */
export function PillTabNav({
  activeId,
  ariaLabel,
  items,
  onChange,
  className,
  componentInstance,
  sticky = false,
}: PillTabNavProps) {
  const navClassName = [
    NAV_CLASS,
    sticky ? `${NAV_CLASS}--sticky` : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav
      className={navClassName}
      data-component-instance={componentInstance}
      aria-label={ariaLabel}
    >
      {items.map((item) => {
        const selected = activeId === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={selected ? `${TAB_CLASS} ${ACTIVE_CLASS}` : TAB_CLASS}
            data-component-instance={item.componentInstance}
            aria-current={selected ? "page" : undefined}
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
